/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/
window.createCookie = require("./vendor/cookie");

// App Requires
require('./app/primary-navigation');
require('./app/search');
require('./app/gallery-slider');
require('./app/testimonial-slider');
require('./app/accordions');
require('./app/modals');
require('./app/tabs');
require('./app/number-counter');
require('./app/alerts');
require('./app/video');